/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 * Lazy loading of the component PageCollectiveProduct
 *
 * @author Evgeniy Naumov
 * @version 1.23.0
 * @since 1.23.0
 */

import loadable from '@utils/loadable';

export default loadable(
    () => import(/* webpackChunkName: "PageCollectiveProduct" */ './PageCollectiveProduct'),
    undefined,
);
